/**
 * Composite SVG Group for nested hierarchies and synchronized transforms.
 */
import { SVGObject, SVGObjectConfig } from './SVGObject';
import { Stage } from '../core/Stage';

export class GroupObject extends SVGObject {
  private children: SVGObject[] = [];

  constructor(config: SVGObjectConfig) {
    super({ ...config, type: 'group' });
  }

  public addChild(child: SVGObject): void {
    this.children.push(child);
    this.container.appendChild(child.getContainer());
  }

  public removeChild(childId: string): void {
    const idx = this.children.findIndex(c => c.id === childId);
    if (idx !== -1) {
      const child = this.children[idx];
      child.destroy();
      this.children.splice(idx, 1);
    }
  }

  public getChildren(): SVGObject[] {
    return [...this.children];
  }

  public render(): void {
    for (const child of this.children) {
      child.render();
    }
  }

  public override update(time: number, delta: number): void {
    super.update(time, delta);
    for (const child of this.children) {
      child.update(time, delta);
    }
  }
}
